import React, { useEffect, useRef, useState } from 'react'
import CommunityList from '../game/detail/Community/comments/CommunityList.js'
import { CSSTransition } from 'react-transition-group'
import { useLocation } from 'react-router-dom'
// import Article from './../../Article.js';
import { NavLink } from '../../lib/Navigation.js'
import URI from "urijs";
import { useScroll } from 'ahooks'
import Dialog from '../../lib/Dialog'
import Manager from '../components/Manager.js'
import '../game/detail/Community/css/Community.css'
import general from '../../general.js'
import { useLocalStorageState } from 'ahooks'

export default props => {

  const router = [
    {
      id: 'all',
      component: CommunityList,
      name: '全部',
      tagid:'-1'
    },
    {
      id: 'comment',
      component: CommunityList,
      name: '评论',
      tagid:'1'
    },
    // {
    //   id: 'active',
    //   component: Article,
    //   name: '#活动',
    //   tagid:''
    // },
    {
      id: 'index',
      component: CommunityList,
      name: '攻略',
      tagid:'2'
    },
    {
      id: 'question',
      component: CommunityList,
      name: '问答',
      tagid:'3'
    },
  ]

  const [idx,setIdx] = useState(-1)
  const [isSearch] = useState(false)
  const [search_info] = useState('')
  const [alert,setAlert] = useState(false)
  const [sort] = useState('new_time')
  const [top,setTop] = useState(0)
  const scroll = useScroll()
  const [item,setItem] = useLocalStorageState('chat-community-item',{})
  const [init,setInit] = useState(false)

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const icon = searchParams.get('icon');
  const name = searchParams.get('name');
  const code = searchParams.get('code');
  const nameRemark = searchParams.get('nameRemark');
  const game_id = searchParams.get('game_id');

  useEffect(()=>{
    if (props.active && icon && name && code && nameRemark && game_id) {
      setItem({
        game_image:{
          thumb: icon
        },
        game_name: name,
        game_id: game_id,
        nameRemark: nameRemark,
        game_classify_type: code
      })
    }
  },[props.active,icon,name,code,nameRemark,game_id])
  
  useEffect(()=>{
    if (props.active){
      props.setTitle(
        top >= 100 && item ? <div className='chat-community-detail' style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div style={{display:'flex',alignItems:'center'}}>
            <img src={item.game_image.thumb} alt="" width={26} height={26}/>
            <div style={{fontSize:'15px',color:'#282828',paddingLeft:'10px'}}>{item.game_name}</div>
          </div>
          <NavLink to={'/game?id=' + item.game_id} className='game-detail'>游戏详情</NavLink>
        </div> : ''
      )
    }
  },[props.active,top])

  useEffect(()=>{
    if (props.active){
      setTop(scroll.top)
    }
  },[scroll])

  useEffect(()=>{
    if (props.active && idx === -1){
      setIdx(0)
    }
  },[props.active])

  const handleInit = ()=>{
    setInit(true)
  }
  
  return (
    <div className='community'>
      <div className="community-container chat-community-container">

        {item && init && <div className="game" style={{
            display:'flex',
            alignItems:'center',
            backgroundColor:'white',
            padding:'15px 15px 20px',
          }}>
          <img src={item.game_image?.thumb} alt="" height={75}/>
          <div className="content" style={{paddingLeft:'10px'}}>
            <div style={{fontSize:'16px',color:'#282828',fontWeight:'500'}}>{item.game_name}</div>
            <div style={{fontSize:'13px',color:'#999'}}>{item.game_classify_type?.trim()} · {item.nameRemark}</div>
            <NavLink to={'/game?id=' + item.game_id} style={{fontSize:'13px',color:'#282828'}}>查看游戏详情 {'>'}</NavLink>
          </div>
        </div>}

        {init && <div className="chat-type">
          <div className="index">
            {router.map((item,index)=>{
              return (
                <div className='index-container' onClick={()=>{setIdx(index);Manager.push({event_id:`D-4-${index+2}`})}}>
                  <div className={'name ' + (idx === index ? 'active' : '')}>{item.name}</div>
                </div>
              )
            })}
          </div>
        </div>}

        <div className={'community-main'} style={{minHeight:'100vh'}}>
        {router.map((item,index)=>{
          return (
            <div className={'community-main-item ' + (index === idx ? 'active' : '')}>
              <item.component 
                init={handleInit}
                active={index === idx && props.active === true} 
                topic_id={props.query.id}
                tagid={item.tagid}
                game={props.game}
                sort={sort.sort}
                search={search_info}
                community={true}
                isSearch={isSearch}>
              </item.component>
            </div>
          )
        })}
        </div>
        <div className="publish" onClick={()=>{setAlert(true);Manager.push({event_id:'D-4-9'})}}>
          <img src="resources/community/publish.png" alt="" />
          <img style={{position:'absolute',top:'-6px',right:'-3px'}} height={13} src="resources/250410/publish.png" alt="" />
        </div>
        <CSSTransition in={alert} timeout={250} unmountOnExit={true}>
          <div className="publish-alert">
            <div className="publish-mask" onClick={()=>setAlert(false)}></div>
            <div className="publish-container">
              <div className="header">
                <NavLink to={URI('https://api3.app.99maiyou.com/communityRewards').toString()}
                  iframe={{title: '奖励规则'}}
                  user={false}
                >
                  <div className="rule">
                    <img src="resources/community/rule.png" alt="" />
                    &nbsp;<span>奖励规则</span>
                  </div>
                </NavLink>
                
                <div className="close" onClick={()=>setAlert(false)}>
                  <img src="resources/community/close.png" alt="" />
                </div>
              </div>
              <div className="content">
                <NavLink to={'/publish?tagid=1&topic_id=' + props.game?.game_info?.maiyou_gameid}>
                  <div className="item" onClick={()=>{setAlert(false);Manager.push({event_id:'D-4-9-1'})}}>
                    <img className='icon' src="resources/community/leave_comment.png" alt="" />
                    <img className='logo' src="resources/community/prizes.png" alt="" />
                    <div className="text">发评论</div>
                  </div>
                </NavLink>
                <NavLink 
                  to={props.game?.played ? '/publish?tagid=2&topic_id=' + props.game?.game_info?.maiyou_gameid : ''}
                  onClick={()=>{
                    Manager.push({event_id:'D-4-9-2'})
                    if (!props.game?.played){
                      Dialog.info('只有玩过该游戏才能发布攻略！')
                    }
                  }}>
                  <div className="item" onClick={()=>setAlert(false)}>
                    <img className='icon' src="resources/community/leave_strategy.png" alt="" />
                    <img className='logo' src="resources/community/prizes.png" alt="" />
                    <div className="text">发攻略</div>
                  </div>
                </NavLink>
                <NavLink to={'/publish?tagid=3&topic_id=' + props.game?.game_info?.maiyou_gameid}>
                  <div className="item" onClick={()=>{setAlert(false);Manager.push({event_id:'D-4-9-3'})}}>
                    <img className='icon' src="resources/community/leave_question.png" alt="" />
                    <div className="text">问大神</div>
                  </div>
                </NavLink>
              </div>
              <div className="cancel" onClick={()=>setAlert(false)}>取消</div>
            </div>
          </div>
        </CSSTransition>
      </div>
    </div>
  )
}
